import * as React from 'react';
import { CheckSymbol, RadioSymbol } from '../..';
import { OptionDescription, OptionSelectMark } from '../option';
import { SelectOption } from '../select-option';
import { SelectOptions } from '../select-options';
import { SelectItem, SelectType } from '../types';
import { isMultiple } from '../select-type';
import styles from './index-group.scss';
import { OptionsPaginator } from 'ui/common/select/options-paginator';

export interface GroupProps {
  valueItems: SelectItem[];
  groupName: string;
  groupOptions: SelectItem[];
  onSelectOption: (item: SelectItem) => void;
  selectType?: SelectType;
  textPageOf?: string;
}

interface ItemProps {
  item: SelectItem;
  isSelected: boolean;
  onSelectOption: (item: SelectItem) => void;
  selectType: SelectType;
}

const IndexItem = ({ item, isSelected, onSelectOption, selectType }: ItemProps) => {
  const selectSymbol = isMultiple(selectType) ? 
      <CheckSymbol /> : 
      <RadioSymbol />;

  return (
    <SelectOption key={item.value} selectType={selectType} hasChildren={false}>
      <OptionSelectMark 
        selectType={selectType} 
        item={item} 
        onSelect={onSelectOption}
        isSelected={isSelected}
      />
      <OptionDescription 
        item={item} 
        showIcons={false} 
        selectSymbol={selectSymbol}
      />
    </SelectOption>
  );
};

export const IndexGroup = ({
  valueItems,
  groupName,
  groupOptions,
  onSelectOption,
  selectType,
  textPageOf
}: GroupProps) => {
  
  const selectedValues = valueItems.map(i => i.value as number);

  return (
    <div className={`row ${styles.alphabetSection}`}>
      <div className="col col-auto">
        <div className={styles.alphabetSectionLetter}>{groupName}</div>
      </div>
      <div className="col">
        <OptionsPaginator options={groupOptions} textPageOf={textPageOf} selectedValues={selectedValues}>
          {currentOptions =>
            <SelectOptions>
              {currentOptions && currentOptions.map((item) => 
                <IndexItem 
                  key={`${item.value}_${item.description}`}
                  item={item} 
                  isSelected={selectedValues.indexOf(item.value as number) > -1}
                  onSelectOption={onSelectOption}
                  selectType={selectType}
                />
              )}
            </SelectOptions>
          }
        </OptionsPaginator>
      </div>
    </div>
  );
};
